import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import Fade from "@mui/material/Fade";
import { Box, IconButton, Avatar, Typography } from "@mui/material";
import CustomTypography from "../../Typography";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { getCurrencySymbol } from "../../../Utils/CountriesData/getCountriesData";
import {
  getColors,
  tooltipSx,
  arrowSx,
  tooltipWrapper,
  tooltipHeading,
  supplierBox,
  supplierRow,
  supplierInfo,
  supplierName,
  supplierPrice,
  priceBox,
  imageWrapper,
  imageStyle,
  leftNavButton,
  rightNavButton,
  imageContainer,
  supplierBoxWrapper,
} from "../styles";
import { useTranslation } from "react-i18next";
import { formatPrice } from "../../../Helpers/formating";

const SupplierProfileModalTooltip = ({
  title,
  children,
  placement = "top",
  moreInfo,
  communitySuppliers,
  mode = "dark",
}) => {
  const { t } = useTranslation("single-service-accordion");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const colors = getColors(mode);

  const handlePrevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) =>
      prev > 0 ? prev - 1 : moreInfo?.images?.length - 1 || 0
    );
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) =>
      prev < (moreInfo?.images?.length - 1 || 0) ? prev + 1 : 0
    );
  };

  const renderTooltipContent = () => {
    if (communitySuppliers?.length > 0) {
      return (
        <Box sx={tooltipWrapper}>
          <Typography sx={tooltipHeading(colors)}>
            {t("other_suppliers_in_your_community")}
          </Typography>
          <Box className="custom-scrollbar" sx={supplierBoxWrapper}>
            <Box sx={supplierBox(colors.borderColor)}>
              {communitySuppliers.map((supplier, index) => {
                const formattedPrice = formatPrice(supplier.price);
                return (
                  <Box
                    key={supplier.id}
                    sx={supplierRow(
                      index === communitySuppliers.length - 1,
                      colors.borderColor
                    )}
                  >
                    <Box sx={supplierInfo(colors.borderColor)}>
                      <Avatar
                        src={supplier.display_image_url}
                        alt={supplier.business_name}
                        sx={{ width: 23, height: 23 }}
                      />
                      <Typography sx={supplierName(colors.textColor)}>
                        {supplier.business_name}
                      </Typography>
                    </Box>
                    <Box sx={priceBox}>
                      <Typography sx={supplierPrice(colors.textColor)}>
                        {formattedPrice
                          ? `${
                              getCurrencySymbol(supplier.currency) || "$"
                            }${formattedPrice}`
                          : "-"}
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Box>
      );
    }

    return (
      <Box sx={imageContainer}>
        {moreInfo?.images?.length > 0 && (
          <Box sx={imageWrapper}>
            <img
              src={moreInfo.images[currentImageIndex]}
              alt={`Variant ${currentImageIndex + 1}`}
              style={imageStyle}
            />
            {moreInfo.images.length > 1 && (
              <>
                <IconButton
                  size="small"
                  onClick={handlePrevImage}
                  sx={leftNavButton}
                >
                  <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={handleNextImage}
                  sx={rightNavButton}
                >
                  <ArrowForwardIosIcon fontSize="small" />
                </IconButton>
              </>
            )}
          </Box>
        )}
        {(moreInfo?.text || title) && (
          <CustomTypography
            props={{ color: "#FFFFFF", fontSize: "15px", fontWeight: "400" }}
          >
            {moreInfo?.text || title}
          </CustomTypography>
        )}
      </Box>
    );
  };

  return (
    <Tooltip
      title={renderTooltipContent()}
      arrow
      placement={placement}
      enterTouchDelay={0}
      leaveTouchDelay={999999}
      slots={{
        transition: Fade,
      }}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -6],
              },
            },
            {
              name: "flip",
              options: {
                fallbackPlacements: ["bottom", "top"],
              },
            },
            {
              name: "preventOverflow",
              options: {
                padding: 8,
              },
            },
          ],
        },
        tooltip: {
          sx: tooltipSx(colors),
        },
        arrow: {
          sx: arrowSx(colors),
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default SupplierProfileModalTooltip;
